module.exports = __webpack_public_path__ + "static/assets/35dfabb0e712ee128d2449992538bd9a.svg";